import { CircularProgress } from "@mui/material";
import React, { useState } from "react";
import { useForm } from "react-hook-form";
import "./ContactForm.css";

const ContactForm = () => {
  const [isLoading, setisLoading] = useState(false);
  const { register, handleSubmit, reset } = useForm();
  const onSubmit = (data) => {
    setisLoading(true);
    fetch(`${process.env.REACT_APP_FORMSPREE_URL}`, {
      method: "POST",
      headers: {
        "content-type": "application/json",
        accept: "application/json",
      },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.ok) {
          alert("Message sent successfully");
          reset();
        } else {
          alert("Something went wrong");
        }
      })
      .catch(() => alert("Something went wrong"))
      .finally(() => setisLoading(false));
  };
  return (
    <form className="contactform" onSubmit={handleSubmit(onSubmit)}>
      <label htmlFor="contact-name" className="sr-only">Your name</label>
      <input
        id="contact-name"
        type="text"
        {...register("name")}
        placeholder="Your name"
        className="jinput"
        autoComplete="name"
        required
      />
      <label htmlFor="contact-email" className="sr-only">Your email</label>
      <input
        id="contact-email"
        type="email"
        {...register("email")}
        placeholder="Your email"
        className="jinput"
        autoComplete="email"
        required
      />
      <label htmlFor="contact-message" className="sr-only">Your message</label>
      <textarea
        id="contact-message"
        {...register("message")}
        placeholder="Your message"
        className="jinput"
        rows="8"
        required
      />
      <button type="submit" className="jbutton contactButton" disabled={isLoading}>
        {isLoading && <CircularProgress size={15} color="inherit" />}
        <span>{isLoading ? "Sending..." : "Send"}</span>
      </button>
    </form>
  );
};

export default ContactForm;
